
import PropTypes from 'prop-types';

import AreasOfWorkView from "./AreasOfWorkView";
import {formatNumberWithCustomSymbol} from "../../assets/salaryformat";
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
const BiodataViewFields =  ({ profile,children }) => {
const { t } = useTranslation();
  const data = profile;

  const {user}=useAuth();//it could be undefined if not logged in, for Employer Biodata

    const calculateAge = (dob) => {
      const birthDate = new Date(dob);
      const today = new Date();
  
      let age = today.getFullYear() - birthDate.getFullYear();
  
      const monthDifference = today.getMonth() - birthDate.getMonth();
      const dayDifference = today.getDate() - birthDate.getDate();
  
  
      if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
        age--;
      }
  
      return age;
    }
      const parseDMYToDate = (dmy) => {
    const [day, month, year] = dmy.split("/");

    return new Date(`${year}-${month}-${day}`);
  }



  return (
  <>
  {/* Profile Header */}
      <div className="text-center mb-4">
        <div className="mb-4">
          {data.imgprofile ? (
            <img
              className="avatar-img rounded"
              src={data.imgprofile}
              width="200"
              height="200"
              alt="User"
            />
          ) : (
            <i className="fas fa-user text-muted" style={{ fontSize: "100px" }}></i>
          )}

        </div>
        <h4 className="mt-3 fw-bold text-primary">{data.name || "N.A."}</h4>
      </div>
      {children}
     {/* Personal Info Card */}
      <div className="card shadow mb-4">
        <div className="card-header bg-primary-kflow text-white fw-bold">
         { t("(A) Personal Information")}
        </div>
        <div className="card-body row g-3 text-sm" style={{ color: 'black' }}>
          <Field label={t("Reference Number")} value={data.code} />
          <Field label={t("Date of Birth")} value={data.dob} />
          <Field label={t("Age")} value={data.dob ? calculateAge(parseDMYToDate(data.dob)) : "N.A"} />
          <Field label={t("Place of Birth")} value={data.pob} />
          <Field label={t("Nationality")} value={data.nationality} />
          <Field label={t("Contact Number")} value={data.contact ?? "N.A."} />


          <Field label={t("Religion")} value={data.religion} />
          <Field label={t("Education Level")} value={data.education} />
          <Field label={t("Marital Status")} value={data.marital} />
          <Field label={t("Number of Siblings")} value={data.siblings} />
          {/*<Field label="Number of Children" value={data.enfants} />*/}
          {data.children_age && <ChildrenAgeView children_age={data.children_age} />}

          <Field label={t("Height")} value={data.height ? `${data.height} cm` : "N.A."} />
          <Field label={t("Weight")} value={data.weight ? `${data.weight} kg` : "N.A."} />
          <Field label={t("Passport")} value={data.passport} />
          <Field label={t("Passport Ready")} value={data.passport_check ? t("Yes") : t("No")} />

         {/* <Field label={t("Salary")} value={'SGD : ' + (data.salaries.SGD ? data.salaries.SGD : "N.A.") + ' MYR : ' + (data.salaries.MYR ? data.salaries.MYR : "N.A.")} />*/}
           <Field label={t("Salary")} value={formatNumberWithCustomSymbol(data.salaries.SGD)} />

          <Field label={t("Residential Address")} value={data.address} />
          <Field label={t("Port/Airport for Repatriation")} value={data.airport} />

        </div>
      </div>

      {/* Medical + Food Card */}
      <div className="card shadow mb-4">
        <div className="card-header bg-primary-kflow text-white fw-bold">
          {t("(B) Medical & Dietary Info")}
        </div>
        <div className="card-body" style={{ color: 'black' }}>
          <Field label={t("Allergies")} value={data.allergies} />
          <Field label={t("Illnesses")} value={(data.illnesses || []).join(", ") || "N.A."} />
          <Field label={t("Disabilities")} value={data.disabilities} />
          <Field label={t("Dietary Restrictions")} value={data.diet} />
          <Field label={t("Preferred Rest Days per Month")} value={data.rest_day} />

       {(data.food_preference?.pork || data.food_preference?.beef || data.food_preference?.other) && (
  <div className="mt-3">
    <strong>{t("Food Preferences")}:</strong>
    <ul className="ms-3 mb-2">
      {data.food_preference?.pork && <li>{t("No Pork")}</li>}
      {data.food_preference?.beef && <li>{t("No Beef")}</li>}
      {data.food_preference?.other && <li>{t("Other")}: {data.food_preference.other}</li>}
    </ul>
  </div>
)}

          <Field label={t("Other Remarks")} value={data.remarks} />
        </div>
      </div>

      {/* Interview Info */}
      <div className="card shadow mb-4">
        <div className="card-header bg-primary-kflow text-white fw-bold">
          (C) {t("Interview Availability")}
        </div>
        <div className="card-body " style={{ color: 'black' }}>
          <Field
            label={t("Interview Methods")}
            value={(data.interview_method || []).join(", ") || "N.A."}
          />
          <Field
            label={t("Interview Availability")}
            value={(data.interview_availability || []).join(", ") || "N.A."}
          />
        </div>
      </div>

      {/* Employment History */}
      <div className="card shadow mb-4">
        <div className="card-header bg-primary-kflow text-white fw-bold">
          {t("(D) Employment History")}
        </div>
        <div className="card-body" style={{ color: 'black' }}>
          <Field label={t("FDW Declaration")} value={data.fdw_declaration ? t("Yes") : t("No")} />
          <Field label={t("Interviewed by Singapore EA")} value={data.singapore_ea ? t("Yes") : t("No")} />
          <Field label={t("Interviewed by Overseas Training Centre")} value={data.overseas_training ? t("Yes") : t("No")} />
          <Field label={t("Foreign Training Centre / EA")} value={data.foreign_training_centre} />
          <Field label={t("Certification / Audit")} value={data.certification} />

          <AreasOfWorkView profile={data} />
          <Field label={t("Other skills")} value={data.other_skills ? data.other_skills : "N.A."} />

          <div className="mt-4">
            <h6 className="text-decoration-underline fw-bold">{t("Past Employers")}</h6>
            {data.employment && data.employment.length > 0 ? (
              data.employment.map((emp, index) => (
                <div key={index} className="border rounded p-3 mb-3 bg-light">
                  <p><strong>{t("Country")}:</strong> {emp.employment_country}</p>
                  <p><strong>{t("From")}:</strong> {emp.employment_from}</p>
                  <p><strong>{t("To")}:</strong> {emp.employment_to}</p>
                  <p><strong>{t("Duties")}:</strong> {emp.employment_duties}</p>
                  <p><strong>{t("Employer")}:</strong> {emp.employment_employer}</p>
                  {/* <p><strong>Feedback:</strong> {data[`feedback_employer_${index + 1}`]}</p> */}
                </div>
              ))
            ) : (
              <p>{t("No employment history provided.")}</p>
            )}
          </div>
          
          <Field
            label={t("Previous Experience in Singapore")}
            value={data.singapore_experience}
          />
          {
            (data.singapore_experience === "Yes" || data.singapore_experience === "yes") && (
              <div className="mt-4">
                <h6 className='text-decoration-underline fw-bold'>{t("Feedback from Previous Employers in Singapore")}</h6>
                {
                  data.feedback_employer_1 && (
                    <div className="card border rounded p-3 mb-3 bg-light">
                      <strong>{t("Employer 1")}: </strong> <br /> { data.feedback_employer_1 }
                    </div>
                  )
                }
                {
                  data.feedback_employer_2 && (
                    <div className="card border rounded p-3 mb-3 bg-light">
                      <strong>{t("Employer 2")}: </strong> <br /> { data.feedback_employer_2 }
                    </div>
                  )
                }
              </div>
            )
          }
        </div>
      </div>

      {/* */}

      <div className="card shadow mb-5">
        <div className="card-header bg-primary-kflow text-white fw-bold">
          {t("Languages")}
        </div>
        <div className="card-body" style={{ color: 'black' }}>
          <Field label={t("Languages")} value={(data.languages || []).join(", ") || "N.A."} />
        </div>
      </div>


      {/* Final Remarks */}
      <div className="card shadow mb-5">
        <div className="card-header bg-primary-kflow text-white fw-bold">
          (E) {t("Other Remarks")}
        </div>
        <div className="card-body" style={{ color: 'black' }}>
          <Field label={t("Other Remarks")} value={data.other_remarks} />
        </div>
      </div>
  </>
  );
}
const ChildrenAgeView = ({ children_age }) => {
  const { t } = useTranslation();
    const hasChildren = Array.isArray(children_age) && children_age.length > 0;
  return (
     <div className="col-md-12 mb-2">
      {hasChildren ? (
        <>
          <strong>{t("Children")} ({children_age.length}):</strong> {t("Ages")}:
          <div className="d-inline-flex flex-wrap gap-2 align-items-center">
            {children_age.map((age, index) => (
              <span key={index} className="badge bg-primary">
                {age}
              </span>
            ))}
          </div>
        </>
      ) : (
        <p><strong>{t("Children")}:</strong> N.A.</p>
      )}
    </div>
  );
};
ChildrenAgeView.propTypes = {
  children_age: PropTypes.arrayOf(PropTypes.number).isRequired,
};
BiodataViewFields.propTypes = {
  profile: PropTypes.object.isRequired,

  children: PropTypes.node,
};
const Field = ({ label, value, full }) => (
  <div className={`col-md-${full ? "12" : "6"} mb-2`}>
    <strong>{label}:</strong> {value || "N.A."}
  </div>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  full: PropTypes.bool,
};
export default BiodataViewFields;    